module.exports = __webpack_public_path__ + "static/AirPlay_overview-f24f34a6136c4c2778c40207c60ca218.jpeg";